var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloseGrey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "05C11519-EFE4-4A57-B5DD-CEE431AEA887") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "editing-profile---desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "D/edit-basics",
    transform: "translate(-976.000000, -80.000000)",
    fill: "#999999",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "desktop/close",
    transform: "translate(689.000000, 80.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/16px/close/gray",
    transform: "translate(287.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.337325624,23.6626744 C-0.0920821893,23.2332666 -0.0920821893,22.5370589 0.337325624,22.1076511 L10.4449767,12 L0.287217394,1.84224064 C-0.114516408,1.44050684 -0.0920821893,0.766733437 0.337325624,0.337325624 C0.766733437,-0.0920821893 1.44050684,-0.114516408 1.84224064,0.287217394 L12,10.4449767 L22.1076511,0.337325624 C22.5370589,-0.0920821893 23.2332666,-0.0920821893 23.6626744,0.337325624 C24.0920822,0.766733437 24.0920822,1.46294106 23.6626744,1.89234887 L13.5550233,12 L23.7127826,22.1577594 C24.1145164,22.5594932 24.0920822,23.2332666 23.6626744,23.6626744 C23.2332666,24.0920822 22.5594932,24.1145164 22.1577594,23.7127826 L12,13.5550233 L1.89234887,23.6626744 C1.46294106,24.0920822 0.766733437,24.0920822 0.337325624,23.6626744 Z",
    id: "Combined-Shape"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseGrey);
export default __webpack_public_path__ + "static/media/close_grey.c7e0a19dac44818cf06ed027b4428c9d.svg";
export { ForwardRef as ReactComponent };